import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Toll } from '../../models/components-general/menu-toll.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-tools-menu',
  templateUrl: './tools-menu.component.html',
  standalone: true,
  imports: [MatTooltipModule, MatIcon, MatButtonModule],
})
export class ToolsMenuComponent {
  @Input() hidenScrollRight = false;
  @Input() hidenScrollLeft = false;
  @Output() emitButton = new EventEmitter<Toll>();
  @Output() emitPixels = new EventEmitter<number>();
  @Input() disableSaveFrom = ''; // status para desabilitar un boton cuando function es 'saveFrom',
  @Input() hidenVertical = false;
  @Input() tollArray: Toll[] = [
    {
      icon: 'backup',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'normal',
    },
    {
      icon: 'class',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'normal',
    },
    {
      icon: 'check_circle_outline',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'normal',
    },
    {
      icon: 'build',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'normal',
    },
    {
      icon: 'not_interested',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'red',
    },
    {
      icon: 'clear',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'red',
    },
    {
      icon: 'check',
      tolltip: 'CARGA DE DOCUMENTOS',
      type: 'green',
      function: 'saveFrom',
    },
  ];

  public mainButtonPress(toll: Toll): void {
    this.emitButton.emit(toll);
  }
}
